export const SHARE_SCOPE = {
  PROPERTY: "property",
  EXPERIENCE: "experience",
  MEDIA_ITEM: "media_item",
} as const;

export type SHARE_SCOPE = (typeof SHARE_SCOPE)[keyof typeof SHARE_SCOPE];
